import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseFormComponent } from '../base-form/base-form.component';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MeterService } from 'src/app/services/meter.service';
import { MeterControlModel } from 'src/app/models/meter-control-model';
import { ZoneModel } from 'src/app/models/zone-model';
import { ZoneService } from 'src/app/services/zone.service';

@Component({
  selector: 'app-cloud-configuration-form',
  templateUrl: './cloud-configuration-form.component.html',
  styleUrls: ['./cloud-configuration-form.component.scss'],
})
export class CloudConfigurationFormComponent extends BaseFormComponent {
  public meters: Array<MeterControlModel> = [];
  public zones: Array<ZoneModel> = [];

  constructor(
    translator: TranslateService,
    changeDetection: ChangeDetectorRef,
    formBuilder: UntypedFormBuilder,
    private meterService: MeterService,
    private zoneService: ZoneService
  ) {
    super(
      translator,
      changeDetection,
      formBuilder.group({
        logoUrl: ['', Validators.pattern(/^(http[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/)],
        backgroundUrl: ['', Validators.pattern(/^(http[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/)],
        productionMeterId: [[]],
        consumptionMeterId: [[]],
        zoneGroups: formBuilder.array([]),
      })
    );

    this.registerFormArray('zoneGroups', (values) =>
      formBuilder.group({
        name: [values?.name || '', Validators.required],
        dashboard: [values?.dashboard || false, Validators.required],
        zones: [values?.zones || [], values?.dashboard ? null : Validators.required],
        stats: formBuilder.array(values?.stats || []),
      })
    );

    this.registerFormArray('zoneGroups[?].stats', (values) =>
      formBuilder.group({
        label: [values?.label || ''],
        values: [values?.values || []],
        units: [values?.units || ''],
      })
    );

    this.registerInputValuesModifier((values) => {
      return {
        ...values,
        zoneGroups: (values?.zoneGroups || [{ name: 'Dashboard', dashboard: true }]).map((zoneGroup: any) => ({
          ...zoneGroup,
          zones: (zoneGroup?.zones || []).map((zone: any) => zone?.id || zone),
        })),
      };
    });
  }

  private async init() {
    this.meters = await this.meterService.getAllControls();
    this.zones = await this.zoneService.getZones();
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }
}
